import { render, staticRenderFns } from "./SelectorTeste_Sim_Nao.vue?vue&type=template&id=3d6175df&scoped=true"
import script from "./SelectorTeste_Sim_Nao.vue?vue&type=script&lang=js"
export * from "./SelectorTeste_Sim_Nao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6175df",
  null
  
)

export default component.exports